"use strict";
exports.__esModule = true;
exports.useFirstRender = void 0;
var react_1 = require("react");
function useFirstRender() {
    var firstRender = react_1.useRef(true);
    react_1.useEffect(function () {
        firstRender.current = false;
    }, []);
    return firstRender.current;
}
exports.useFirstRender = useFirstRender;
